<template>
  <v-app id="sustaine">
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="mini"
      :width="250"
      app
      color="#2A3F54"
      dark
      permanent
      dense
    >
      <!-- color="#73879C" -->
      <v-list dense>
        <v-list-item>
          <v-list-item-icon>
            &nbsp;&nbsp;<img :src="require('@/assets/img/logo-icon.png')" alt="Sustaine" width="32"/>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="text-left title font-weight-bold white--text">
              <span class="headline hidden-sm-and-down">Sustaine<small>&trade;</small></span>
            </v-list-item-title>
          </v-list-item-content>        
        </v-list-item>

        <!-- nav item loop  ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
        <template v-for="(item, i) in items">

          <!-- nav items (expanding) -->
          <v-list-group v-if="item.children.length > 0 && userHasRole(item.text, item.roles)" :key="i" dense>

            <v-icon slot="appendIcon" color="orange darken-2">{{ item.iconClose }}</v-icon>

            <template v-slot:activator>
              <v-list-item dense>
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-2">
                     {{ item.text }}
                  </v-list-item-title>
                </v-list-item-content>              
              </v-list-item>
            </template>
            
            <!-- children -->            
            <template v-for="(child, c) in item.children">
              <v-list-item 
                :to="child.href" 
                v-if="userHasRole(child.text, child.roles)  && !mini" 
               :key="`${i}${c}`"
                dense
                >
                <v-list-item-icon>
                  <v-icon small color="secondary" class="pl-5">{{ child.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                 <v-list-item-subtitle class="text-left caption font-weight-normal">
                    {{ child.text }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item> 
            </template>
          </v-list-group>
          
          <!-- no children -->
          <v-list-item
            :to="item.href"
            v-if="item.children.length === 0 && userHasRole(item.text, item.roles)"
            :key="`no-child${i}`"
            dense>
            <v-list-item-icon>
             <v-icon class="ml-4">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text-left subtitle font-weight-black">
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>        
          </v-list-item>

          <v-divider :key="`d${i}`" width="95%"></v-divider>

        </template>

      </v-list>

    </v-navigation-drawer>

    <!-- top logo/toolbar ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <v-app-bar
      app
      color="#EDEDED"
      light
      outlined
      dense>
        <v-app-bar-nav-icon @click.stop="mini = !mini">
          <v-icon size="32">reorder</v-icon>
        </v-app-bar-nav-icon>
        
        <!-- spacer -->      
        <div class="flex-grow-1"></div>
      
        <!-- facility selector -->
        <AppFacilitySelector></AppFacilitySelector>
        <AppUserMenu></AppUserMenu>

    </v-app-bar>

    <!-- page content ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <v-content>
      <v-container fluid>
        <v-row class="align-start justify-center">
          <v-col>

            <AppTitleBar />

            <v-fade-transition mode="out-in">
              <router-view :key="getFacilityId" v-if="!$root.loading" />
            </v-fade-transition>
              
            <AppScrollTo />

          </v-col>
        </v-row>
      </v-container>
    </v-content>

    <AppFooter></AppFooter>

  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
  export default {
    name: "DefaultLayout",
    props: {
      source: {
        type: String,
        required: false,
        default: undefined
      }      
    },
    data: () => ({
      drawer: false,
      mini: false,
      version: '',
      username: '',
      roles: '',
      items: [
        { id: 1, text: 'Home',  model: false, icon: "home", href: "/home", children: [] },
        {
          id: 2, 
          text: 'Operate',
          model: true,
          icon: 'mdi-state-machine',
          iconOpen: 'arrow_drop_up',
          iconClose: 'arrow_drop_down',          
          roles: ["ADMIN", "GUIDANCE_REPORT", "GUIDANCE_OPS", "ROLE_PERFORMANCE_REPORT"],
          children: [
            { icon: 'arrow_right', text: 'Guidance',              href: '/operate/guidance',  roles: ["GUIDANCE_REPORT", "GUIDANCE_OPS"] },
            { icon: 'arrow_right', text: 'Generator Run Times',   href: '/operate/generator', roles: ["PERFORMANCE_REPORT"] },
            { icon: 'arrow_right', text: 'Multiple DA',           href: '/demo/guidance/1',   roles: ["ADMIN"] },
            { icon: 'arrow_right', text: 'Peak & RT Stacked',     href: '/demo/guidance/2',   roles: ["ADMIN"] },
            { icon: 'arrow_right', text: 'RT By DA Proxy',        href: '/demo/guidance/3',   roles: ["ADMIN"] },
            { icon: 'arrow_right', text: 'RT Extended',           href: '/demo/guidance/4',   roles: ["ADMIN"] },
            { icon: 'arrow_right', text: 'RT Aborted',            href: '/demo/guidance/5',   roles: ["ADMIN"] },
            { icon: 'arrow_right', text: 'NCP Ceiling',           href: '/demo/guidance/7',   roles: ["ADMIN"] },
          ],
        },
        {
          id: 3, 
          text: 'Plan',
          model: true,
          icon: 'mdi-strategy',
          iconOpen: 'arrow_drop_up',
          iconClose: 'arrow_drop_down',
          roles: ["ADMIN"],
          children: [
            { icon: 'arrow_right', text: 'Simulation Engine',             href: '/demo/engine',      roles: ["ADMIN"] },
            { icon: 'arrow_right', text: 'Residential Simulation',        href: '/demo/engine/resi', roles: ["ADMIN"] },
            { icon: 'arrow_right', text: 'Solar Simulation',              href: '/demo/solar',       roles: ["ADMIN"] },
            { icon: 'arrow_right', text: 'Healthcare Simulation',         href: '/demo/health',      roles: ["ADMIN"] }
          ],
        },
        {
          id: 4,
          text: 'Report',
          model: true,
          icon: 'mdi-file-chart',
          iconOpen: 'arrow_drop_up',
          iconClose: 'arrow_drop_down',
          roles: ["ADMIN", "PERFORMANCE_REPORT", "SUSTAINABILITY_REPORT"],
          children: [
            { icon: 'arrow_right', text: 'Performance Summary',   href: '/report/performance/summary',  roles: ["PERFORMANCE_SUMMARY"] },
            { icon: 'arrow_right', text: 'Performance',           href: '/report/performance',          roles: ["PERFORMANCE_REPORT"] },
            { icon: 'arrow_right', text: 'Sustainability',        href: '/demo/report/sustain',         roles: ["ADMIN"] },
            { icon: 'arrow_right', text: 'Single 5CP Run',        href: '/demo/performance/1',          roles: ["ADMIN"] }
            // { icon: 'arrow_right', text: 'Daily Spend #1',  href: '/demo/report/spend',           roles: ["ADMIN"] },
            // { icon: 'arrow_right', text: 'Daily Spend #2',  href: '/demo/report/spend2',          roles: ["ADMIN"] }
          ],
        },
        {
          id: 5,
          text: 'Configure',
          model: true,
          icon: 'settings',
          iconOpen: 'arrow_drop_up',
          iconClose: 'arrow_drop_down',
          roles: ["ADMIN_FACILITY"],
          children: [
            { icon: 'arrow_right', text: 'Your Facility',            href: '/config/facility',     roles: ["ADMIN_FACILITY"] },
            { icon: 'arrow_right', text: 'Your Assets',              href: '/config/assets',       roles: ["ADMIN_FACILITY"] }
          ],
        },
        {
          id: 6,
          text: 'Admin',
          model: true,
          icon: 'vpn_key',
          iconOpen: 'arrow_drop_up',
          iconClose: 'arrow_drop_down',
          roles: ["ADMIN_PEAK_DAY", "ADMIN_MASTER_CONSTRAINTS"],
          children: [
            { icon: 'arrow_right', text: 'Coincident Peak Config', href: '/admin/peak',                roles: ["ADMIN_PEAK_DAY"] },
            { icon: 'arrow_right', text: 'Master Constraints',    href: '/admin/constraints/master',  roles: ["ADMIN_MASTER_CONSTRAINTS"] }
          ],
        },
        {
          id: 7,
          text: 'Internal Only',
          model: true,
          icon: 'mdi-shield-key-outline',
          iconOpen: 'arrow_drop_up',
          iconClose: 'arrow_drop_down',
          roles: ["ADMIN_SUPER"],
          children: [
            { icon: 'arrow_right', text: 'Accounts',              href: '/admin/accounts',            roles: ["ADMIN_SUPER"] },
            { icon: 'arrow_right', text: 'Facilities',            href: '/admin/facilities',          roles: ["ADMIN_SUPER"] }
          ],
        }
      ]
    }),
    computed: {
      ...mapGetters(['getAccount', 'getFacilityId', 'hasAccess']),
    },
    created() {
      this.username = this.getAccount.username
      this.roles = this.getAccount.roles.toString()
      this.version = process.env.VUE_APP_VERSION
    },
    methods: {
      userHasRole(item, roles) {
        if (typeof roles === 'undefined') {
          return true
        }
        if (roles.length === 0) {
          return true
        }

        let allow = false // assume no access
        for (var r = 0; r < roles.length; r++) {          
          allow = allow || this.hasAccess(roles[r])
        }
        return allow
      }
    }
  }
</script>
<style lang="scss" scoped>
/* Links */
a:link,
a:visited,
a:hover {
  color: rgba(255,255,255,.65) !important;
  text-decoration: none;
}
.v-list-item { padding: 0 1px; }

</style>